module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-新闻资讯banner.484c6ea2.png";